import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getLoginUrl } from '@sravni/utils/lib/auth';

import { useUser } from '../../../entities/user';

export type AdminProtectedRouteProps = {
    children: React.ReactNode;
}
export const AdminProtectedRoute = (props: AdminProtectedRouteProps) => {
    const { children } = props;
    const [user] = useUser();
    
    useEffect(() => { 
        if (!user) {
            window.location.href = getLoginUrl();
        }
    }, [user]);
    
    if (!user) return null;
    
    if (user && !user.isAdmin) {
        return <Navigate to="/forbidden"/>
    }

    return <>{children}</>;
};